import React from "react";

// Wave 18b.5 bug batch v2 hotfix (Vania 6 Oct 2026 · 11:40 EAT · live
// QA) · the drive-pipeline sources (`poster_drop`, `joy`) were missing
// from this map, so every Drive card fell back to `manual` and the chip
// read "Manual". That's the user-visible bug Vania caught. Keep every
// pipeline origin named here explicitly; the fallback is `manual` only
// for truly manual rows.
const SOURCE_META = {
  telegram:    { label: "Telegram",    cls: "bg-sky-50 text-sky-700 border-sky-200" },
  whatsapp:    { label: "WhatsApp",    cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  jsonld:      { label: "JSON-LD",     cls: "bg-neutral-100 text-neutral-700 border-neutral-300" },
  scrape:      { label: "Scrape",      cls: "bg-amber-50 text-amber-700 border-amber-200" },
  self_submit: { label: "Self-submit", cls: "bg-fuchsia-50 text-fuchsia-700 border-fuchsia-200" },
  poster_drop: { label: "poster drop", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  joy:         { label: "joy (legacy)",cls: "bg-neutral-100 text-neutral-700 border-neutral-300" },
  manual:      { label: "Manual",      cls: "bg-neutral-100 text-neutral-700 border-neutral-300" },
};

export function SourceBadge({ source, captured_by, className = "" }) {
  // hotfix 2 (Vania 6 Oct 2026 · 12:30 EAT · live QA) · legacy Joy rows
  // carry source="manual" + captured_by="joy", so the previous mapping
  // on `source` alone still rendered them as MANUAL. Route by
  // captured_by first so joy legacy rows always say "joy (legacy)";
  // fall back to source for every other origin.
  const key = captured_by === "joy" ? "joy"
            : captured_by === "poster_drop" ? "poster_drop"
            : source;
  const s = SOURCE_META[key] || SOURCE_META.manual;
  return (
    <span data-testid={`source-badge-${key || "manual"}`}
          className={`inline-flex items-center rounded-md border ${s.cls} px-1.5 py-0.5 text-[10.5px] font-semibold uppercase tracking-[0.14em] ${className}`}>
      {s.label}
    </span>
  );
}
